import {ChangeDetectionStrategy, Component, Input, SimpleChanges} from '@angular/core';
import {AladinSkyLayersService} from "../aladin-sky-layers.service";
import {SkyLayer} from "../aladin-sky-layers-options/aladin-sky-layers-options.component";
import {Observable} from "rxjs";

const displayOptionsOnTopStyle =  'position: absolute; top: 10px';
const displayOptionsOnBottomStyle =  'position: absolute; bottom: 10px';
const displayOptionsRightStyle =  'position: absolute; right: 10px; top: 20px';

@Component({
  selector: 'asax-sky-view-aladin-sky-layers-container',
  templateUrl: './aladin-sky-layers-container.component.html',
  styleUrls: ['./aladin-sky-layers-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AladinSkyLayersContainerComponent {
  @Input() height: number;
  @Input() width: number;

  skyLayers: Observable<SkyLayer[]>;

  baseImageForProgress: SkyLayer;
  overlayImageForProgress: SkyLayer;
  alphaForProgress: number;

  indexActiveSky: number;

  optionsViewPlacement: string = 'top';
  optionsViewStyle: string = displayOptionsOnTopStyle;

  constructor(private readonly aladinLayersService: AladinSkyLayersService) {
    this.skyLayers = this.aladinLayersService.getSkyLayers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.height || changes.width) {
      if (this.width < 500) {
        this.optionsViewPlacement = 'right';
        this.optionsViewStyle = displayOptionsRightStyle;
      } else if (this.height < 450) {
        this.optionsViewPlacement = 'bottom';
        this.optionsViewStyle = displayOptionsOnBottomStyle;
      } else {
        this.optionsViewPlacement = 'top';
        this.optionsViewStyle = displayOptionsOnTopStyle;
      }
    }
  }

  onOutSkyLayers(skyLayers: SkyLayer[]): void {
    this.aladinLayersService.setSkyLayers(skyLayers);
  }

  onBaseImageForAladin(baseImage: SkyLayer): void {
    this.aladinLayersService.setBaseSky(baseImage);
  }

  onOverlayImageForAladin(overlayImage: SkyLayer): void {
    this.aladinLayersService.setOverlaySky(overlayImage);
  }

  onAlphaForAladin(alpha: number): void {
    this.aladinLayersService.setAlpha(alpha);
  }
}
